import { Injectable, computed, inject, signal } from '@angular/core';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  private appService = inject(AppService);

  constructor() {
    this.screen.set({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    window.addEventListener('resize', () => {
      this.screen.set({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    });
  }

  objectFilter: string[] = [];

  screen = signal<{ width: number; height: number }>({
    width: null,
    height: null,
  });

  camera = signal<{ width: number; height: number }>({
    width: null,
    height: null,
  });

  video = signal<{ width: number; height: number }>({
    width: null,
    height: null,
  });

  overlay = computed(() => {
    const videoInput = this.appService.demoMode()
      ? this.video()
      : this.camera();

    const scale = Math.min(
      videoInput.width / this.screen().width,
      videoInput.height / this.screen().height,
    );

    const height = Math.round(videoInput.height / scale);
    const width = Math.round(videoInput.width / scale);

    return {
      width,
      height,
    };
  });

  shift = computed(() => ({
    x: Math.round((this.screen().width - this.overlay().width) / 2),
    y: Math.round((this.screen().height - this.overlay().height) / 2),
  }));

  convertBoxCoordinates = (coord: {
    width: number;
    height: number;
    moveX?: number;
    moveY?: number;
  }) => ({
    min: {
      x: this.overlay().width / 2 - coord.width / 2 + (coord.moveX ?? 0),
      y: this.overlay().height / 2 - coord.height / 2 + (coord.moveY ?? 0),
    },
    max: {
      x: this.overlay().width / 2 + coord.width / 2 + (coord.moveX ?? 0),
      y: this.overlay().height / 2 + coord.height / 2 + (coord.moveY ?? 0),
    },
  });

  convertCenterCoordinates = (coord: { moveX?: number; moveY?: number }) => ({
    x: this.overlay().width / 2 + (coord.moveX ?? 0),
    y: this.overlay().height / 2 + (coord.moveY ?? 0),
  });
}
